import { IntlShape } from 'react-intl';

export const getApiError = (intl: IntlShape, status: number): { MESSAGE: string; TITLE: string; STATUS: number } => {
	return {
		MESSAGE: intl.formatMessage({ id: `pages:orderDetails:error:apiError:${status}:message` }),
		TITLE: intl.formatMessage({ id: `pages:orderDetails:error:apiError:${status}:title` }),
		STATUS: status,
	};
};

export const getPreAuthApiError = (intl: IntlShape, status: number): { MESSAGE: string; TITLE: string; STATUS: number } => {
	return {
		MESSAGE: intl.formatMessage({ id: `pages:orderDetails:error:preAuthApiError:${status}:message` }),
		TITLE: intl.formatMessage({ id: `pages:orderDetails:error:preAuthApiError:${status}:title` }),
		STATUS: status,
	};
};
